// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"5":"create_strategy","669":"marketplace","741":"marketplace_detail","768":"mystrategies","824":"portfolio","845":"profile","943":"mint_strategy"}[chunkId] + "." + {"5":"c88d3e63","669":"daf4d770","741":"1c6ad111","768":"defaf0e6","824":"ee9d1ccc","845":"5abcafc8","943":"aed8f8d5"}[chunkId] + ".css";
};